import i18n from '@/localisation/i18n';
import useAppStore from '@/store/app';
import { Link } from 'react-router-dom';

export const EmptyAside = () => {
  const { closeDrawer } = useAppStore();

  return (
    <>
      <div className="mb-6 text-additional">{i18n.t('no.clients')}</div>
      <Link
        className="btn flex w-full items-center border-none bg-[#42404D] text-sm text-white"
        to={'/new-client'}
        onClick={closeDrawer}
      >
        {i18n.t('add.clients')}
        <img
          width={14}
          height={14}
          className="rotate-180"
          src="/icons/back_arrow.svg"
          alt="arrow"
        />
      </Link>
    </>
  );
};
